module.exports = __webpack_public_path__ + "img/banner4.fae03b5d.png";